import { t } from "i18next";
import type { JSX } from "react";
import { cn } from "@/lib/utils";
import { TooltipHelp } from "../TooltipHelp";

interface Props {
  onClick: () => void;
  disabled?: boolean;
  // Why the button is disabled and how to enable it, shown under it.
  disabledHint?: string;
}

const HINT_ID = "upload-audio-disabled-hint";

export const UploadAudioButton = ({
  onClick,
  disabled = false,
  disabledHint,
}: Props): JSX.Element => {
  const hint = disabled ? disabledHint : undefined;
  return (
    <div className="flex flex-col items-center gap-1">
      <div className="flex items-center gap-2">
        <button
          type="button"
          aria-describedby={hint ? HINT_ID : undefined}
          disabled={disabled}
          className={cn(
            "text-tinted-grey-3 text-base font-semibold cursor-pointer  underline ",
            disabled
              ? "cursor-not-allowed opacity-50"
              : "hover:text-primary hover:underline-offset-2 transition duration-300",
          )}
          onClick={onClick}
        >
          {t("visits.sidebar.uploadFile")}
        </button>
        <TooltipHelp content={t("error.formRecorder.supportedFormat")} />
      </div>
      {hint && (
        <p
          className="max-w-xs text-center text-sm text-muted-foreground"
          id={HINT_ID}
        >
          {hint}
        </p>
      )}
    </div>
  );
};
